import error from './error';
import info from './info';
import log from './log';
import warn from './warn';
// We want to import utils as consoleEvents.error, consoleEvents.info, etc.
// eslint-disable-next-line no-restricted-syntax
export default {
    info,
    log,
    error,
    warn,
};
//# sourceMappingURL=index.js.map